import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { EditorState } from 'draft-js';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { TextEditor } from '@/imports/ui/components/TextEditor';
import {
  PlatformContextPreviewLink,
  useLinkPreview,
} from '@/imports/ui/components/context/PlatformContextPreviewLink';

export const Body: React.FC<{
  formLabel: string;
  validationMessage: string;
  placeholder: string;
}> = ({ formLabel, validationMessage, placeholder }) => {
  const methods = useFormContext();
  const {
    formState: { errors },
    getValues,
    watch,
    setValue,
  } = methods;
  const body = watch('body');

  const onHidePreviewHandler = async (
    editorState: EditorState
  ): Promise<void> => {
    setValue('body', editorState);
  };

  const { linkPreview, hidePreview } = useLinkPreview({
    editorState: body,
    onHidePreviewHandler,
  });

  return (
    <>
      <FormControl isInvalid={!!errors.body?.message}>
        <FormLabel>{formLabel}</FormLabel>
        <Controller
          name="body"
          rules={{
            validate: (value) =>
              getValues('title') !== undefined && getValues('title').length > 0
                ? true
                : !!value.getCurrentContent().getPlainText() &&
                  value.getCurrentContent().getPlainText().length > 0
                ? true
                : validationMessage,
            deps: ['title'],
          }}
          render={({ field: { onChange, value, ref, onBlur } }) => (
            <TextEditor
              ariaLabel="Create post body"
              placeholder={placeholder}
              isMentionsActive
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
            />
          )}
        />
        <FormErrorMessage>{errors.body?.message}</FormErrorMessage>
      </FormControl>
      <PlatformContextPreviewLink
        linkPreview={linkPreview}
        canEdit
        onClose={hidePreview}
        w="full"
      />
    </>
  );
};
